module.exports = __webpack_public_path__ + "static/media/Diabetes_ensiapu_2016.9f405dff.jpg";